import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PublicNavHeader from '../components/PublicNavHeader';
import Footer from '../components/Footer';

import {
  ArrowRight,
  Briefcase,
  Calendar,
  ChatText,
  FileText,
  Phone,
  TrendUp
} from '@phosphor-icons/react';
const UseCases = () => {
  const useCases = [
    { icon: Phone, title: 'Voice Agents', description: 'Automate inbound and outbound calls with AI-powered voice agents.', category: 'Customer Service' },
    { icon: ChatText, title: 'Chat Agents', description: 'Deploy intelligent chatbots for 24/7 customer support.', category: 'Customer Service' },
    { icon: Calendar, title: 'Booking Agents', description: 'Automate appointment scheduling and reminders.', category: 'Operations' },
    { icon: FileText, title: 'Document Processing', description: 'Extract and process information from documents at scale.', category: 'Operations' },
    { icon: TrendUp, title: 'Sales Automation', description: 'Qualify leads and automate sales follow-ups.', category: 'Sales' },
    { icon: Briefcase, title: 'HR Automation', description: 'Streamline recruitment and employee onboarding.', category: 'HR' }
  ];

  return (
    <>
      <SEO title="Use Cases - Man & Machine" description="Discover how businesses use Man & Machine to deploy AI agents across their operations." />
      <PublicNavHeader />
      
      <div className="min-h-screen bg-[#0a0a0f]">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#6366F1]/10 via-transparent to-[#EC4899]/10" />
          
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center max-w-3xl mx-auto"
            >
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                Use Cases
              </h1>
              <p className="text-lg text-[#A0AEC0]">
                See how businesses deploy AI agents to transform their operations.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 pb-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {useCases.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
                className="glass rounded-2xl p-6 group hover:border-[#6366F1]/30 transition-all"
              >
                <span className="text-xs text-[#6366F1] font-medium mb-2 block">{item.category}</span>
                <div className="w-12 h-12 rounded-xl bg-[#6366F1]/10 flex items-center justify-center mb-4">
                  <item.icon size={24} className="text-[#6366F1]" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                <p className="text-[#A0AEC0] text-sm">{item.description}</p>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/partner-pro/ai-workforce/marketplace"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white font-semibold rounded-full hover:opacity-90 transition-opacity"
            >
              Explore Agent Templates
              <ArrowRight size={18} />
            </Link>
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default UseCases;